module.exports = __webpack_public_path__ + "static/media/GolosText-VariableFont_wght.bf5a52ea.ttf";